import React from 'react';
import { ApSecondaryNav, ApButtonTab } from '@alixpartners/ui-components';
import { NavLink, useLocation } from 'react-router-dom';
import { SpeedToMarketPageWrapper, ContentDiv } from './SecondaryNav.styles';
import { SPEED_TO_MARKET_NAV_CONFIG } from './routes';
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';
import CategoryWidget from 'SpeedToMarket/Tabs/CategoryWidget/CategoryWidget';

const ContentComponent = {
	categoryWidgets: CategoryWidget,
};

export const SecondaryNav = () => {
	const location = useLocation();
	return (
		<SpeedToMarketPageWrapper>
			<ApSecondaryNav
				left={
					<React.Fragment>
						{SPEED_TO_MARKET_NAV_CONFIG.map(({ label, path }) => {
							return (
								<NavLink to={path} key={path}>
									<ApButtonTab isSelected={location.pathname.includes(path)}>
										{label}
									</ApButtonTab>
								</NavLink>
							);
						})}
					</React.Fragment>
				}
			/>
			<ContentDiv>
				<Switch>
					{SPEED_TO_MARKET_NAV_CONFIG.map(({ name, path }) => {
						return (
							<Route
								key={path}
								path={path}
								component={ContentComponent[name]}
							/>
						);
					})}
				</Switch>
			</ContentDiv>
		</SpeedToMarketPageWrapper>
	);
};

export default SecondaryNav;
